import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
  mutation GenerateFotoFlatZipMutation($input: GenerateFotoFlatZipInput!) {
    generateFotoFlatZip(input: $input) {
      url
    }
  }
`;

function commit(environment, eventId, startnumber, variant, callback) {
  return commitMutation(environment, {
    mutation,
    variables: {
      input: {
        eventId,
        startnumber,
        variant,
      },
    },
    onCompleted: (response, errors) => {
      if (errors) {
        callback && callback(errors[0]);
      } else {
        callback && callback(null, response.generateFotoFlatZip.url);
      }
    },
    onError: err => {
      callback && callback(err);
    },
  });
}

export default { commit };
